import { atom } from 'jotai';
import type { AcctStateRefResponseType } from 'types/api/acctStateRefResponseType';
/**
 * ワークスペース共通項目
 */
export type AcctStateType = AcctStateRefResponseType & {
  initialized: boolean;
  proxyLogin: boolean;
  proxyCompanyCd: string | null;
};

export const AcctState = atom<AcctStateType>({
  user: null,
  company: null,
  usage: null,
  activeContent: null,
  initialized: false,
  proxyLogin: false,
  proxyCompanyCd: null,
});
